import React from 'react'
import './KnowledgeCell.css'
import { ArrowRightIcon, DeleteIcon } from '../../../conf/images'

interface KnowledgeCellProps {
    title?: string
    answer?: string
    deleteable?: boolean
    onClick?: (e: React.MouseEvent) => void
}
const KnowledgeCell: React.FC<KnowledgeCellProps> = (props) => {
    const { title, answer, onClick, deleteable } = props
    return (
        <div
            className={`knowledge-cell ${deleteable ? 'deletting' : ''}`}
            onClick={onClick}
        >
            <div className='content'>
                <p className='title ellipsis'>{title}</p>
                {answer && (
                    <p className='answer ellipsis'>
                        <span className='label'>答案</span>
                        {answer}
                    </p>
                )}
            </div>

            {!deleteable ? (
                <img className='icon' src={ArrowRightIcon} alt='>' />
            ) : (
                <img className='icon' src={DeleteIcon} alt='x' />
            )}
        </div>
    )
}

export default KnowledgeCell
